import { ResourceLoader } from "../../earth/core/resourceLoader";
import { KeyedMetrics, MetricKey } from "../model/keyedMetrics";
import { Media } from "../model/media";
import { Metric } from "../model/metric";
import { MetricsByBrand } from "../model/metricsByBrand";
import { MetricsByCountry } from "../model/metricsByCountry";
import { MetricType } from "../model/metricType";
import { Sentiment } from "../model/sentiment";

type MetricKeyResolver = (name: string) => MetricKey;

export class MetricsLoader {
    static async loadMetricsForType(metricType: MetricType): Promise<MetricsByCountry> {
        switch (metricType) {
            case MetricType.Engagement:
            case MetricType.Publications:
                return MetricsLoader.loadMetricsByCountry(metricType.jsonFilePath);
            case MetricType.Media:
                return MetricsLoader.loadMultiMetricsByCountry(metricType.jsonFilePath, Media.mediaWithName);
            case MetricType.Sentiment:
                return MetricsLoader.loadMultiMetricsByCountry(metricType.jsonFilePath, Sentiment.sentimentWithName);
            default:
                throw new Error(`Unsupported metric-type ${metricType}`);
        }
    }

    private static async loadMetricsByCountry(jsonPath: string): Promise<MetricsByCountry> {
        let json = await ResourceLoader.loadAsJson(jsonPath);
        return MetricsLoader.jsonToMetricsByCountry(json);
    }

    private static async loadMultiMetricsByCountry(jsonPath: string, keyResolver: MetricKeyResolver): Promise<MetricsByCountry> {
        let json = await ResourceLoader.loadAsJson(jsonPath);
        return MetricsLoader.jsonToMultiMetricsByCountry(json, keyResolver);
    }

    private static jsonToMetricsByCountry(json: any): MetricsByCountry {
        let metricsByCountry = new MetricsByCountry();
        for (let countryIsoCode in json) {
            metricsByCountry.setMetricsForCountryIsoCode(countryIsoCode, MetricsLoader.jsonToMetricsByBrand(json[countryIsoCode]));
        }
        return metricsByCountry;
    }

    private static jsonToMetricsByBrand(json: any): MetricsByBrand {
        let metricsByBrand = new MetricsByBrand();
        for (let brand in json) {
            metricsByBrand.setMetricForBrandNamed(brand, Metric.fromValue(json[brand]));
        }
        return metricsByBrand;
    }

    private static jsonToMultiMetricsByCountry(json: any, keyResolver: MetricKeyResolver): MetricsByCountry {
        let metricsByCountry = new MetricsByCountry();
        for (let countryIsoCode in json) {
            let metricsByBrand = MetricsLoader.jsonToMultiMetricsByBrand(json[countryIsoCode], keyResolver);
            metricsByCountry.setMetricsForCountryIsoCode(countryIsoCode, metricsByBrand);
        }
        return metricsByCountry;
    }

    private static jsonToMultiMetricsByBrand(json: any, keyResolver: MetricKeyResolver): MetricsByBrand {
        let metricsByBrand = new MetricsByBrand();
        for (let brand in json) {
            let subMetrics = MetricsLoader.jsonToKeyedMetrics(json[brand], keyResolver);
            metricsByBrand.setMetricForBrandNamed(brand, Metric.fromSubMetrics(subMetrics));
        }
        return metricsByBrand;
    }

    private static jsonToKeyedMetrics(json: any, keyResolver: MetricKeyResolver): KeyedMetrics {
        let metrics = new KeyedMetrics();
        for (let keyName in json) {
            let key = keyResolver(keyName);
            metrics.setMetricForKey(key, Metric.fromValue(json[keyName]));
        }
        return metrics;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/dataAccess/metricsLoader.ts